.root {
  composes: field from '../field.module.css';
  display: block;
  width: 100%;
  min-height: 38px;
  padding: 9px 12px;
  resize: vertical;
}

.root::placeholder {
  color: var(--ink-3);
}
